'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { classNames } from '@/shared/lib/classnames/classnames';
import { Button } from '@/shared/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/shared/ui/dialog';
import Input from '@/shared/ui/input';
import { useSearchHeader } from '../../model/useSearchHeader';
import { SearchContentWrapper } from './search/SearchContentWrapper';
import baseIcons from '@/shared/assets/sprites/base.sprite.svg';
interface Props {
  cityAlias: string;
  isMobileModalOpen?: boolean;
  onMobileModalClose?: () => void;
}
export const HeaderSearch: React.FC<Props> = ({
  cityAlias,
  isMobileModalOpen = false,
  onMobileModalClose
}) => {
  const t = useTranslations('shared.header');
  const {
    query,
    isDropdownOpen,
    isLoading,
    searchResults,
    isEmptySearch,
    loadNewPage,
    setLoadNewPage,
    handleSearchChange,
    handleSearchClick,
    searchRef
  } = useSearchHeader();
  return <>
      <div className="mx-4 hidden max-w-md grow lg:block">
        <div className="relative" ref={searchRef}>
          <svg className="absolute left-3 top-1/2 z-50 size-6 -translate-y-1/2 stroke-slate-950" data-sentry-element="svg" data-sentry-source-file="HeaderSearch.tsx">
            <use xlinkHref={`${baseIcons}#search`} data-sentry-element="use" data-sentry-source-file="HeaderSearch.tsx" />
          </svg>

          <Input type="search" value={query} onChange={handleSearchChange} onClick={handleSearchClick} placeholder={`${t('search')}`} className="h-8 w-full rounded-md bg-gray-100 py-2 pl-10 pr-2 placeholder:text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" data-sentry-element="Input" data-sentry-source-file="HeaderSearch.tsx" />

          {/* Десктопный dropdown */}
          <div className={classNames('absolute left-0 top-full z-[60] mt-2 hidden h-[400px] w-full max-w-md rounded-2xl bg-white shadow-xl transition-all duration-300 ease-in-out lg:block', {
          'invisible translate-y-2 scale-95 opacity-0': !isDropdownOpen,
          'visible translate-y-0 scale-100 opacity-100': isDropdownOpen
        })}>
            <div className="h-full overflow-y-auto p-2 scroll-width-none">
              <SearchContentWrapper isEmptySearch={isEmptySearch} isLoading={isLoading} loadNewPage={loadNewPage} searchResults={searchResults} cityAlias={cityAlias} setLoadNewPage={setLoadNewPage} data-sentry-element="SearchContentWrapper" data-sentry-source-file="HeaderSearch.tsx" />
            </div>
          </div>
        </div>
      </div>

      {/* Мобильная модалка поиска */}
      <Dialog open={isMobileModalOpen} data-sentry-element="Dialog" data-sentry-source-file="HeaderSearch.tsx">
        <DialogContent variant="full" removeScrollLock overlayClick={onMobileModalClose} className="h-dvh min-h-dvh overflow-y-scroll bg-white p-4" data-sentry-element="DialogContent" data-sentry-source-file="HeaderSearch.tsx">
          <DialogHeader data-sentry-element="DialogHeader" data-sentry-source-file="HeaderSearch.tsx">
            <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="HeaderSearch.tsx">
              <div className="flex w-full items-center gap-3">
                <div className="relative flex-1">
                  <svg className="absolute left-3 top-1/2 z-50 size-6 -translate-y-1/2 stroke-slate-950" data-sentry-element="svg" data-sentry-source-file="HeaderSearch.tsx">
                    <use xlinkHref={`${baseIcons}#search`} data-sentry-element="use" data-sentry-source-file="HeaderSearch.tsx" />
                  </svg>

                  <Input type="search" value={query} onChange={handleSearchChange} onClick={handleSearchClick} placeholder={`${t('search')}`} className="h-10 w-full rounded-md bg-gray-100 py-2 pl-10 pr-2 placeholder:text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" autoFocus data-sentry-element="Input" data-sentry-source-file="HeaderSearch.tsx" />
                </div>

                <Button variant="text" size="sm" onClick={onMobileModalClose} className="px-3 py-2 text-sm text-textPrimary" data-sentry-element="Button" data-sentry-source-file="HeaderSearch.tsx">
                  {t('cancel')}
                </Button>
              </div>
            </DialogTitle>
          </DialogHeader>

          <div className="mt-4 flex-1 overflow-y-auto">
            <SearchContentWrapper isEmptySearch={isEmptySearch} isLoading={isLoading} loadNewPage={loadNewPage} searchResults={searchResults} cityAlias={cityAlias} setLoadNewPage={setLoadNewPage} data-sentry-element="SearchContentWrapper" data-sentry-source-file="HeaderSearch.tsx" />
          </div>
        </DialogContent>
      </Dialog>
    </>;
};